import { api } from '../api'
import {
  CreateSupporterConsentDecision,
  CreateSupporterConsentDecisionResponse,
} from 'models/ConsentDecision'

export const consentDecisionsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createConsentDecision: builder.mutation<
      CreateSupporterConsentDecisionResponse,
      CreateSupporterConsentDecision & { supporterId: string }
    >({
      query: (createConsentDecisionRequest) => ({
        method: 'POST',
        url: `/supporters/${createConsentDecisionRequest.supporterId}/consent-decisions`,
        body: createConsentDecisionRequest,
      }),
    }),
  }),
})

export const {
  useCreateConsentDecisionMutation,
  endpoints: { createConsentDecision },
} = consentDecisionsApi
